/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/void-dom-elements-no-children */
import React from 'react';
import './styles.less';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { Link } from 'react-router-dom';
import { Status } from '../../../../../components/status';
import StatusButton from '../../../../../components/status-button';
import { BUTTONS_NAMES, BUTTONS_STYLES } from '../../../constants';
import { CustomLoader } from '../../../../../components/custom-loader';

export const ReqStatusActionsView = ({
	status,
	actions,
	onActionButtonClick,
	reqId,
	query,
	badges,
	statusDetailsTimeLineComponent,
	withLabels,
	isReqsSending,
}) => {
	if (isReqsSending.find(el => el.id === reqId)) {
		return (
			<div className={`req-status-actions ${withLabels && 'req-status-actions-with-labels'}`}>
				<CustomLoader />
			</div>
		);
	}

	return (
		<div className={`req-status-actions ${withLabels && 'req-status-actions-with-labels'}`}>
			<div className="req-status-actions__statuses">
				<div className="req-status-actions__title">Статус</div>
				{status && status.link && (
					<Link className="req-status-actions__link" to={`${status.link}${query ? `&${query}` : ''}`}>
						<Status
							status={status}
							isFullwidth
							statusDetailsTimeLineComponent={statusDetailsTimeLineComponent}
						/>
					</Link>
				)}
				{status && !status.link && (
					<Status
						status={status}
						isFullwidth
						statusDetailsTimeLineComponent={statusDetailsTimeLineComponent}
					/>
				)}
			</div>

			{actions && !isEmpty(actions) && (
				<div className="req-status-actions__actions">
					{Object.entries(actions).map(([key, value]) => {
						if (!value || !BUTTONS_NAMES[key]) {
							return null;
						}

						return (
							<div className="req-status-actions__button" key={key}>
								<StatusButton
									button={{ name: BUTTONS_NAMES[key], color: BUTTONS_STYLES[key] }}
									onClick={() => onActionButtonClick(key, reqId)}
								/>
								{badges[key]?.count && (
									<span
										className={`req-status-actions__button-badges req-status-actions__button-badges_${badges[key].color}`}
									>
										{badges[key].count}
									</span>
								)}
							</div>
						);
					})}
				</div>
			)}
		</div>
	);
};

ReqStatusActionsView.propTypes = {
	status: PropTypes.shape({
		name: PropTypes.string.isRequired,
		color: PropTypes.string.isRequired,
		description: PropTypes.any,
		link: PropTypes.string,
	}),
	actions: PropTypes.oneOfType([PropTypes.objectOf(PropTypes.bool), PropTypes.array]),
	onActionButtonClick: PropTypes.func.isRequired,
	reqId: PropTypes.number.isRequired,
	query: PropTypes.string.isRequired,
	badges: PropTypes.objectOf(
		PropTypes.shape({
			count: PropTypes.number.isRequired,
			color: PropTypes.string.isRequired,
		}),
	),
	statusDetailsTimeLineComponent: PropTypes.node,
	withLabels: PropTypes.bool,
	isReqsSending: PropTypes.array,
};
